const FONT_MAP = {
  "Gilroy": {
    body: "'Gilroy-Medium'",
    heading: "'Gilroy-SemiBold'",
    button: "'Gilroy-Medium'",
    input: "'Gilroy-Medium'",
  },
  "Avenir": {
    body: "'Avenir-Roman', sans-serif",
    heading: "'Avenir-Black', sans-serif",
    button: "'Avenir-Medium', sans-serif",
    input: "'Avenir-Roman', sans-serif",
  },
  "Vaud": {
    body: "Vaud, Helvetica, sans-serif",
    heading: "Vaud, Helvetica, sans-serif",
    button: "Vaud, Helvetica, sans-serif",
    input: "Vaud, Helvetica, sans-serif",
  },
  "DM Sans": {
    body: "'DM Sans', sans-serif",
    heading: "'DM Sans', sans-serif",
    button: "'DM Sans', sans-serif",
    input: "'DM Sans', sans-serif",
  },
  "Netflix Sans": {
    body: "'Netflix Sans', sans-serif",
    heading: "'Netflix Sans', sans-serif",
    button: "'Netflix Sans', sans-serif",
    input: "'Netflix Sans', sans-serif",
  },
  "Proxima Nova": {
    body: "'Proxima-Nova', sans-serif",
    heading: "'Proxima-Nova', sans-serif",
    button: "'Proxima-Nova', sans-serif",
    input: "'Proxima-Nova', sans-serif",
  },
  "Trebuchet MS": {
    body: "'Trebuchet-MS-Regular'",
    heading: "'Trebuchet-MS'",
    button: "'Trebuchet-MS-Regular'",
    input: "'Trebuchet-MS-Regular'",
  },
  "Poppins": {
    body: "'Poppins', sans-serif",
    heading: "'Poppins Bold', sans-serif",
    button: "'Poppins', sans-serif",
    input: "'Poppins', sans-serif",
  },
  "Roboto": {
    body: "'Roboto', sans-serif",
    heading: "'Roboto', sans-serif",
    button: "'Roboto', sans-serif",
    input: "'Roboto', sans-serif",
  },
  "Arial": {
    body: "Arial, sans-serif",
    heading: "Arial, sans-serif",
    button: "Arial, sans-serif",
    input: "Arial, sans-serif",
    letterSpacing: "0.5px",
  },
  "Default": {
    body: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    heading: "'Roboto', sans-serif, 'Liberation Mono', 'Courier New', monospace",
    button: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    input: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', 'Liberation Sans', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  },
};

const PUBLISHER_FONT_MAP = {

};

const TEMPLATE_DEFAULTS = {

};

export const handleFontFamily = (config, pubid, templateDefault) => {
  let fontName = null;

  if (config?.FONT && FONT_MAP[config.FONT]) {
    fontName = config.FONT;
  }
  else if (pubid && PUBLISHER_FONT_MAP[pubid]) {
    fontName = PUBLISHER_FONT_MAP[pubid];
  }
  else if (config?.TEMPLATE && TEMPLATE_DEFAULTS[config.TEMPLATE]) {
    fontName = TEMPLATE_DEFAULTS[config.TEMPLATE];
  }
  else {
    fontName = "Default";
  }

  if (fontName && FONT_MAP[fontName]) {
    const fontConfig = FONT_MAP[fontName];
    const root = document.documentElement;

    root.style.setProperty("--font-body", fontConfig.body);
    root.style.setProperty("--font-heading", fontConfig.heading);
    root.style.setProperty("--font-button", fontConfig.button);
    root.style.setProperty("--font-input", fontConfig.input);

    root.style.setProperty(
      "--font-letter-spacing-button",
      fontConfig.letterSpacing || "normal"
    );

    document.body.style.setProperty("font-family", fontConfig.body, "important");
  }
};

export { FONT_MAP };